import { useState, useEffect } from 'react';
import { GamesService } from '../../../shared/src/services/games.service';
import { useTools } from '../contexts';

export const useThumbnailSize = (thumbnailRef, callback) => {
    const tools = useTools();
    const [thumbnailSize, setThumbnailSize] = useState('small');

    useEffect(() => {
        const calculateItemSize = () => {
            if (thumbnailRef?.current) {
                const { width, height } = thumbnailRef.current.getBoundingClientRect();

                setThumbnailSize(GamesService.getThumbnailSizeClass(width, height));

                if (callback) {
                    callback(width);
                }
            }
        };

        // initial calculation
        calculateItemSize();

        // recalculate size classes on resize
        const debouncedSizeCalculation = tools.debounce(calculateItemSize, 50);
        window.addEventListener('resize', debouncedSizeCalculation);

        return () => {
            window.removeEventListener('resize', debouncedSizeCalculation);
        };
    }, [thumbnailRef?.current]);

    return {
        thumbnailSize,
    };
};
